import { Component, OnInit, Inject, HostListener } from '@angular/core';

import { BaseService } from './shared-service/base.service';
import { APP_CONFIG, AppConfig } from './shared-service/app.config';

// import { KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { AuthOIDCService } from './auth/authOIDC.service';
import { AppService } from './app.service';

declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

	status: string = 'Loading..';
	ua: string = window.navigator.userAgent;

	switchAdminToLearnerUrl: string|any;

	@HostListener('window:beforeunload', ['$event']) beforeunloadHandler(event:any) {
		if (this.ua.indexOf("MSIE 10.0") == -1) {
			this.baseService.CloseSCORM();
		}
	}

	constructor(
		private baseService: BaseService,
		@Inject(APP_CONFIG) private config: AppConfig,
		private authOIDCService: AuthOIDCService,
		private appService: AppService
	){
		baseService.loadConfig(config);
	}

	ngOnInit(): void {
		console.log('environment', environment);
		
		this.authOIDCService.keycloak.onTokenExpired = () => {
			this.authOIDCService.updateToken(30);
		}
		const params = new URL(window.location.href).searchParams;

		const metadata = this.appService.getParameterByName('metadata');
		const isLearnerSwitch = this.appService.getParameterByName('isLearnerSwitch');
		const isSpacedLearningLink = this.appService.getParameterByName('isSpacedLearningLink');
		const isProxyLogin = this.appService.getParameterByName('isProxyLogin');
		// check keycloak auth		
		if (!this.authOIDCService.token) {

			if (
				params.get('isLearnerSwitch') || isLearnerSwitch ||
				params.get('metadata') || metadata ||
				params.get('isSpacedLearningLink') || isSpacedLearningLink ||
				params.get('isProxyLogin') || isProxyLogin
			) {
				sessionStorage.setItem('switchAdminToLearnerUrl', window.location.href);
			}
		}
	}

	onActivate(event:any) {
		this.baseService.log('info', "AppComponent Router Active");
		this.baseService.log('info', event);
	};

	onDeactivate(event:any) {
		this.baseService.log('info', "AppComponent Router InActive");
		this.baseService.log('info', event);
	};
}
